export const POPUP_MESSAGE = 'POPUP_MESSAGE';
export const INFO_POPUP_V2 = 'INFO_POPUP_V2';
export const SHARE_POPUP = 'SHARE_POPUP';
